// TODO: loading?

export const listActionStandard = async (data: FormData) => {
  return fetch('/', {
    method: 'post',
    body: data,
    headers: {
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
    .then((res) => res.json())
    .then((jsonRes) => jsonRes)
    .catch((err) => {throw new Error(err)});
};

const createFormDataBase = () => {
  const formData = new FormData();

  // @ts-ignore
  formData.append(window.csrfTokenName, window.csrfTokenValue);

  return formData;
}

// list - add to cart
export const createAddToCartListFormData = (id: string) => {
  const formData = createFormDataBase();

  formData.append('action', 'wishlist/lists/add-to-cart');
  formData.append('listId', id);

  return formData;
};

// list - delete
export const createDeleteListFormData = (id: string) => {
  const formData = createFormDataBase();

  formData.append('action', 'wishlist/lists/delete');
  formData.append('listId', id);

  return formData;
};

// list - create
export const createCreateListFormData = (title: string, handle: string = 'wishlist_group') => {
  const formData = createFormDataBase();

  // @ts-ignore
  const id = window.LIST_TYPES.filter((listType) => listType.handle === handle)[0].id;

  formData.append('action', 'wishlist/lists/create');
  formData.append('typeId', id);
  formData.append('title', title);

  return formData;
};

// list - update
export const createUpdateListFormData = (id: string) => {
  const formData = createFormDataBase();

  formData.append('action', 'wishlist/lists/update');
  formData.append('listId', id);

  return formData;
};

// item - remove
export const createDeleteItemFormData = (itemId: string, listId: string) => {
  const formData = createFormDataBase();

  formData.append('action', 'wishlist/items/remove');
  formData.append('elementId', itemId);
  formData.append('listId', listId);

  return formData;
};

// item - add
export const createAddItemFormData = (itemId: string, listId: string) => {
  const formData = createFormDataBase();

  formData.append('action', 'wishlist/items/add');
  formData.append('elementId', itemId);
  formData.append('listId', listId);

  return formData;
};

// item - update
export const createUpdateItemFormData = (itemId: string, listId: string) => {
  const formData = createFormDataBase();

  formData.append('action', 'wishlist/items/update');
  formData.append('itemId', itemId);
  formData.append('listId', listId);

  return formData;
};


export const openOptionalModal = (configurationInListGlobal: boolean, unavailableProductInListGlobal: boolean) => {
  if (configurationInListGlobal && unavailableProductInListGlobal) {
    // open all modal
    const popupEvent = new CustomEvent('formpopup:open', {
      detail: {
        form: 'wishlist-config-and-unavailable',
        type: 'form',
        size: 'large',
        target: 'form-popup'
      },
    } as any);
    document.dispatchEvent(popupEvent);
  } else if (configurationInListGlobal) {
    // open config modal
    const popupEvent = new CustomEvent('formpopup:open', {
      detail: {
        form: 'wishlist-config',
        type: 'form',
        size: 'large',
        target: 'form-popup'
      },
    } as any);
    document.dispatchEvent(popupEvent);
  } else if (unavailableProductInListGlobal) {
    // open unavailable modal
    const popupEvent = new CustomEvent('formpopup:open', {
      detail: {
        form: 'wishlist-unavailable',
        type: 'form',
        size: 'large',
        target: 'form-popup'
      },
    } as any);
    document.dispatchEvent(popupEvent);
  }

  setTimeout(() => {
    const closeButtons = document.querySelectorAll('.m-popup .js-close-popup');
    closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        document.querySelector('.m-popup.m-popup--is-active')?.classList.remove('m-popup--is-active');
        document.body.classList.remove('m-popup--is-visible');
      })
    });
  }, 1500);
}
